import { Component, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'netfoundry-ui-visualizer-dialog-host',
    template: '<ng-container #host></ng-container>',
    standalone: false,
})
export class VisualizerDialogHostComponent {
    @ViewChild('host', { read: ViewContainerRef, static: true }) host!: ViewContainerRef;
}
